import { CONFIG } from 'src/environments/environment';
import { useSystemStore } from 'src/store/SystemStore';

/** Identity of this compiled JavaScript bundle (also used for source maps). */
export const buildAppVersion = CONFIG.VITE_APP_VERSION;

/** Safe before native detection finishes; the store starts at the build version. */
export function getCurrentAppVersion(): string {
  return useSystemStore.getState().appVersion.current;
}
